var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drop collapse",attrs:{"id":"editCardBlock"}},[_c('PaymentForm',{ref:"paymentForm",attrs:{"input_countries":_vm.countries,"input_states":_vm.states,"input_payment":_vm.inner_payment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }